import { render, staticRenderFns } from "./uboInfoList.vue?vue&type=template&id=8ff51e68&scoped=true&"
import script from "./uboInfoList.vue?vue&type=script&lang=js&"
export * from "./uboInfoList.vue?vue&type=script&lang=js&"
import style0 from "./uboInfoList.vue?vue&type=style&index=0&id=8ff51e68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff51e68",
  null
  
)

export default component.exports